type WebviewPhonePreviewProps = {
	previewUrl: string | null;
	emptyHint?: string;
	iframeBlockedHint?: string;
};

export default function WebviewPhonePreview({
	previewUrl,
	emptyHint = 'Выберите шаблон, чтобы увидеть превью',
	iframeBlockedHint,
}: WebviewPhonePreviewProps) {
	return (
		<div className='mx-auto w-full max-w-[280px]'>
			<div className='rounded-[2rem] border-[10px] border-zinc-800 bg-zinc-900 p-2 shadow-2xl'>
				<div className='overflow-hidden rounded-[1.4rem] bg-black'>
					<div className='flex h-6 items-center justify-center'>
						<div className='h-1.5 w-16 rounded-full bg-zinc-800' />
					</div>
					<div className='aspect-[9/16] w-full bg-zinc-950'>
						{previewUrl ? (
							<iframe
								title='WebView preview'
								src={previewUrl}
								className='h-full w-full border-0 bg-black'
								sandbox='allow-scripts allow-same-origin'
							/>
						) : (
							<div className='flex h-full items-center justify-center px-4 text-center text-xs text-muted-foreground'>
								{emptyHint}
							</div>
						)}
					</div>
				</div>
			</div>
			{previewUrl && iframeBlockedHint ? (
				<p className='mt-2 text-center text-[11px] text-muted-foreground'>{iframeBlockedHint}</p>
			) : null}
		</div>
	);
}
